import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/acesso/pessoa/';

class PessoaService {
    constructor() {
        this.idConta = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByContaFiltro(filtro, tipoTomador) {
        this.idConta = LoginService.currentUserValue.usuario.idConta;
        return axios.get(API_URL + 'filter?idConta='+this.idConta+'&filtro='+filtro+'&tipoPesquisa='+tipoTomador, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    findAllByClienteFiltro(idCliente, filtro, tipoPesquisa){
        return axios.get(API_URL + 'filterCliente?idCliente='+idCliente+'&filtro='+filtro+'&tipoPesquisa='+tipoPesquisa, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }
    
}

export default new PessoaService();